import type { StackProps } from '@mui/material';
import {
  CustomizedAccordion,
  NameBanner,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';
import {
  DescriptionText,
  MainText,
  StyledAccordionStack,
  StyledContentStack,
  StyledStack,
  StyledTextStack,
} from './styles';
import { AccordionData, whatWeDoData } from './whatWeDoData';

export const WhatWeDo = ({ ...props }: StackProps): React.ReactElement => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner type="section" text={'What matters to us?'} />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">{whatWeDoData.mainText}</MainText>
            <DescriptionText variant="strong_400">
              {whatWeDoData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion data={AccordionData()} />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
